export const FETCH_REGIONS = 'FETCH_REGIONS';
export const FETCH_REGIONS_SUCCESS = 'FETCH_REGIONS_SUCCESS';
export const FETCH_REGIONS_FAILED = 'FETCH_REGIONS_FAILED';

export const fetchRegions = forTutorRegistration => ({
  type: FETCH_REGIONS,
  payload: {
    forTutorRegistration,
  },
});

export const fetchRegionsSuccess = data => ({
  type: FETCH_REGIONS_SUCCESS,
  payload: {
    data,
  },
});

export const fetchRegionsFailed = errorMessage => ({
  type: FETCH_REGIONS_FAILED,
  payload: {
    errorMessage,
  },
});

const INIT_STATE = {
  data: [],
  errorMessage: '',
};

// reducers
const reducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_REGIONS_SUCCESS:
      return {
        ...state,
        data: action.payload.data,
      };
    case FETCH_REGIONS_FAILED:
      return {
        ...state,
        errorMessage: action.payload.errorMessage,
      };
    default:
      return state;
  }
};

export default reducer;

export const getRegionsForTutor = state =>
  state.regions.data.filter(r => r.enableForTutor);
export const getRegionsForStudent = state =>
  state.regions.data.filter(r => r.enableForStudent);



// WEBPACK FOOTER //
// ./app/redux/regions.js